<template>
    <div class="balance-container">
        <div class="section-title">{{ title | capitalize }}</div>
        <div
            class="amount-container"
            :class="{'amount-container--loading' : isBalanceLoading}"
            v-if="typeof amount === 'number'"
        >
            <div :class="amountClass">
                {{ amount | twoDecimals }}
            </div>
            <div class="currency">{{ $t('currencyAbbreviation') }}</div>
        </div>
        <div v-else>
            -
        </div>
        <SubtleLink
            v-if="stakeInActiveTickets"
            :link= "{name: routeNames.tickets }"
        >
            {{$t('{amount} {currency} in game', amountInGameData )}}
        </SubtleLink>
        <div v-else-if="isStakeLoading">
            ...{{ $t('loading') }}
        </div>
        <SubtleLink
            v-else
            :link= "{name: routeNames.tickets }"
        >
            {{ $t('Currently you have no active bets') }}
        </SubtleLink>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { currency } from '@modules/shared/filters/numbers.ts';
    import { routeNames } from '@app/router';
    import config from '@config';

    export default {
        name: 'Balance',
        props: {
            amount: {
                type: Number,
                required: false,
                default: null
            },
            title: {
                type: String,
                required: true,
            },
            stakeInActiveTickets: {
                type: Number,
                required: false,
                default: null
            },
            isStakeLoading: {
                type: Boolean,
                required: true,
            }
        },
        created() {
            this.routeNames = routeNames;
        },
        computed: {
            amountPretty() {
                return currency(this.amount);
            },
            isBalanceTooLow() {
                return this.amount < config.app.user.lowBalance;
            },
            amountClass() {
                return [
                    'amount',
                    this.isBalanceTooLow ? 'red' : 'green',
                ];
            },
            stakeInActiveTicketsPretty() {
                return currency(this.stakeInActiveTickets);
            },
            amountInGameData() {
                return {
                    amount: this.stakeInActiveTicketsPretty,
                    currency: this.$t('currencyAbbreviation')
                };
            },
            ...mapGetters('ui/user/account', [
                'isBalanceLoading',
            ]),
        },
    };
</script>


// WEBPACK FOOTER //
// src/app/modules/userProfile/components/Balance.vue